import { render, staticRenderFns } from "./NativeAdPropertiesData.vue?vue&type=template&id=14aad4c4"
import script from "./NativeAdPropertiesData.vue?vue&type=script&lang=js"
export * from "./NativeAdPropertiesData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports